import { EquirectangularAdapter, Viewer } from "@photo-sphere-viewer/core";
import { VisibleRangePlugin } from "@photo-sphere-viewer/visible-range-plugin";

export type ImageViewerOptions = {
    container: string | HTMLElement;
}

export type ImageViewerSize = {
    width: number;
    height: number;
}

export type ImageViewerPanoramaOptions = {
    yaw?: number;
    pitch?: number;
}

export default class ImageViewer {
    #viewer: Viewer;

    public constructor(options: ImageViewerOptions) {
        this.#viewer = new Viewer({
            container: options.container,
            adapter: [EquirectangularAdapter, {
                useXmpData: true,
                shader: true,
            }],
            plugins: [
                VisibleRangePlugin.withConfig({
                    usePanoData: true,
                }),
            ],
            maxFov: 70,
            navbar: ["zoom", "moveLeft", "moveRight", "caption", "fullscreen"],
            lang: {
                zoom: 'Zoom',
                zoomOut: 'Verkleinern',
                zoomIn: 'Vergrößern',
                moveLeft: 'Links',
                moveRight: 'Rechts',
                description: 'Beschreibung',
                download: 'Herunterladen',
                fullscreen: 'Vollbild',
                loading: 'Laden ...',
                menu: 'Menü',
                close: 'Schließen',
                twoFingers: 'Nutzen Sie zwei Finger zum Navigieren',
                ctrlZoom: 'Nutzen Sie [Strg] + Mausrad zum Vergrößern des Bildes',
                loadError: 'Das Panorama kann nicht geladen werden',
                webglError: 'Ihr Browser unterstützt kein WebGL',
            },
        });
    }

    public dispose() {
        this.#viewer.destroy();
        this.#viewer = undefined!;
    }

    public async setPanorama(url: string, options?: ImageViewerPanoramaOptions): Promise<boolean> {
        return await this.#viewer.setPanorama(url, {
            position: {
                yaw: `${options?.yaw ?? 0}deg`,
                pitch: `${options?.pitch ?? 0}deg`,
            },
        });
    }

    public resize(size?: ImageViewerSize) {
        if (size && typeof size.width === "number" && typeof size.height === "number") {
            this.#viewer.resize({
                height: `${size.height}`,
                width: `${size.width}`,
            });
        } else {
            this.#viewer.autoSize();
        }
    }
}
